export type SeverityColor = 'danger' | 'warning' | 'info';
export type SeverityKey = 'high' | 'medium' | 'low';
export type SeverityPriority = 1 | 2 | 3;

const COMBINING_DIACRITICS = /[̀-ͯ]/g;

export function normalizeSeverity(value?: string | null): string {
  return (value ?? '')
    .toString()
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(COMBINING_DIACRITICS, '');
}

export function severityColor(value?: string | null): SeverityColor {
  const n = normalizeSeverity(value);
  if (n === 'ALTA') { return 'danger'; }
  if (n === 'MEDIA') { return 'warning'; }
  return 'info';
}

export function severityKey(value?: string | null): SeverityKey {
  const n = normalizeSeverity(value);
  if (n === 'ALTA') { return 'high'; }
  if (n === 'MEDIA') { return 'medium'; }
  return 'low';
}

export function severityPriority(value?: string | null): SeverityPriority {
  const n = normalizeSeverity(value);
  if (n === 'ALTA') { return 1; }
  if (n === 'MEDIA') { return 2; }
  return 3;
}

export function formatSeverityLabel(value?: string | null): string {
  const n = normalizeSeverity(value);
  if (n === 'ALTA') { return 'Alta'; }
  if (n === 'MEDIA') { return 'Média'; }
  if (n === 'BAIXA') { return 'Baixa'; }
  return toTitle(value);
}

export function toTitle(value?: string | null): string {
  const raw = (value ?? '').toString().trim();
  if (!raw) { return ''; }
  return raw
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .split(' ')
    .map(part => part ? part.charAt(0).toUpperCase() + part.slice(1) : '')
    .join(' ');
}

const SONAR_SEVERITY_LABELS: Record<string, string> = {
  INFO: 'Info', MINOR: 'Minor', MAJOR: 'Major', CRITICAL: 'Critical', BLOCKER: 'Blocker'
};

const SONAR_ISSUE_TYPE_LABELS: Record<string, string> = {
  BUG: 'Bug', CODE_SMELL: 'Code Smell', VULNERABILITY: 'Vulnerability'
};

export function formatSonarSeverity(value?: string | null): string {
  const n = (value ?? '').toString().trim().toUpperCase();
  if (!n) { return ''; }
  return SONAR_SEVERITY_LABELS[n] ?? toTitle(n);
}

export function formatSonarIssueType(value?: string | null): string {
  const n = (value ?? '').toString().trim().toUpperCase();
  if (!n) { return ''; }
  return SONAR_ISSUE_TYPE_LABELS[n] ?? toTitle(n);
}
